// frontend/src/components/promotions/promotionActions.js
//
// Which actions a promotion offers in its current state — the one home for
// that rule. The promotions list renders the answer as the row's next-step
// button and a ⋯ menu (PromotionRowActions).
//
//   apply   draft only: `apply` refuses any other status
//           (api/views/promotions.py PromotionViewSet.apply). The next step
//           of a draft.
//   edit    every status. The next step of a promotion past its draft.
//   delete  every status; the server refuses the delete it cannot carry out
//           and the merchant reads why.

export const PROMOTION_ACTION = Object.freeze({
  APPLY: 'apply',
  EDIT: 'edit',
  DELETE: 'delete',
});

// Every action `promotionActions` can return as `primary`; the row's button is
// as wide as the widest of them, so the buttons line up down the column.
export const PRIMARY_ACTIONS = Object.freeze([PROMOTION_ACTION.APPLY, PROMOTION_ACTION.EDIT]);

/**
 * @param {{ status: string }} promotion  A promotion row; `status` is the
 *   stored one, which is what `apply` checks.
 * @returns {{ primary: string, more: string[] }}
 */
export function promotionActions(promotion) {
  if (promotion.status === 'draft') {
    return { primary: PROMOTION_ACTION.APPLY, more: [PROMOTION_ACTION.EDIT, PROMOTION_ACTION.DELETE] };
  }
  return { primary: PROMOTION_ACTION.EDIT, more: [PROMOTION_ACTION.DELETE] };
}
